import { BaseMetaDatabase } from "namirasoft-core";
import { NSBaseMetaTable } from "./NSBaseMetaTable";
import { NSBaseServer } from "./NSBaseServer";

export abstract class NSBaseMetaDatabase<Server extends NSBaseServer> extends BaseMetaDatabase
{
    public static getServerBaseURL(product_name: string): string
    {
        throw new Error(`NSBaseMetaDatabase.getServerBaseURL was not overriden. Requested: ${product_name}`);
    }
    override tables: { [name: string]: NSBaseMetaTable<Server, any>; } = {};
    public product: {
        id: string;
        name: string;
        headline: string;
        description: string;
        logo: string;
        link: string;
    };
    public abstract getServer(): Server;
    constructor(product: {
        id: string;
        name: string;
        headline: string;
        description: string;
        logo: string;
        link: string;
    })
    {
        super();
        this.product = product;
    }
    getByShortNameOrNull(short_name: string):
        {
            product: {
                id: string;
                name: string;
                headline: string;
                description: string;
                logo: string;
                link: string;
            };
            table: NSBaseMetaTable<NSBaseServer, any>;
        } | null
    {
        for (let table in this.tables)
            if (this.tables[table].uuid.short === short_name)
                return { product: this.product, table: this.tables[table] };
        return null;
    }
    getByShortName(short_name: string):
        {
            product: {
                id: string;
                name: string;
                headline: string;
                description: string;
                logo: string;
                link: string;
            };
            table: NSBaseMetaTable<NSBaseServer, any>;
        }
    {
        let ans = this.getByShortNameOrNull(short_name);
        if (ans)
            return ans;
        throw new Error(`Result could not be found for short name: ${short_name}`);
    }
};